import { render, staticRenderFns } from "./ContentLoaderPayment.vue?vue&type=template&id=204f9a73&"
import script from "./ContentLoaderPayment.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports